export const ButtonHeaderComponent = {
  bindings: {
    icon: '@',
    hasBadge: '<?',
    badgeCount: '<?',
  },
  transclude: true,
  templateUrl: 'components/Buttons/button-header/button-header.html',
};
